import React, { useState } from 'react';

// Components imports
import adminAPIdData from './ReportsData';
import { ReportsData } from './interface.js';
import './Report.css';
import { Container, Button } from 'react-bootstrap';
import { useReportContext } from '../../Context/index';
import ReportModal from './ReportModal/ReportModal';
import AudienceCheckModal from './ReportModal/AudienceCheckModal';
import AdStatsModal from './ReportModal/AdStatsModal';
import OfferScreenStatsModal from './ReportModal/OfferScreenStatsModal';

const Report: React.FC = () => {
    const [rowData] = useState<ReportsData[]>(adminAPIdData);
    const { setReportData, setReportModal } = useReportContext();
    const [audienceCheckReport, setAudienceCheckReport] =
        useState<ReportsData | null>(null);
    const [adStatsReport, setAdStatsReport] = useState<ReportsData | null>(
        null,
    );
    const [offerScreenReport, setOfferScreenReport] =
        useState<ReportsData | null>(null);

    const onClickButton = (props: ReportsData): void => {
        if (props.audienceCheckModal) {
            setAudienceCheckReport(props);
            return;
        }
        if (props.adStatsModal) {
            setAdStatsReport(props);
            return;
        }
        if (props.offerScreenStatsModal) {
            setOfferScreenReport(props);
            return;
        }
        setReportData(props);
        setReportModal(true);
    };
    return (
        // <Container className="bg1">
        //     <Container className="bg2">
        <>
            <Container className="row row-cols-4">
                {rowData
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((el, idx) => {
                        return (
                            <div key={idx}>
                                <Button
                                    style={{ width: '15vw', height: '8vh' }}
                                    className="btn-add"
                                    variant="primary"
                                    onClick={() => onClickButton(el)}
                                >
                                    {el.name}
                                </Button>
                            </div>
                        );
                    })}
            </Container>
            <ReportModal />
            <AudienceCheckModal
                show={audienceCheckReport !== null}
                report={audienceCheckReport}
                onHide={() => setAudienceCheckReport(null)}
            />
            <AdStatsModal
                show={adStatsReport !== null}
                report={adStatsReport}
                onHide={() => setAdStatsReport(null)}
            />
            <OfferScreenStatsModal
                show={offerScreenReport !== null}
                report={offerScreenReport}
                onHide={() => setOfferScreenReport(null)}
            />
        </>
    );
};

export default Report;
